module.exports = __webpack_public_path__ + "static/media/scrollLeftIcon.f25a3814.svg";